export const EDIT_ALERT_TYPE_SUPPORTED_OPEN_MODAL = "EDIT_ALERT_TYPE_SUPPORTED_OPEN_MODAL";
export const EDIT_ALERT_TYPE_SUPPORTED_UPDATE_ALERT_TYPES_REQUEST = "EDIT_ALERT_TYPE_SUPPORTED_UPDATE_ALERT_TYPES_REQUEST";
export const EDIT_ALERT_TYPE_SUPPORTED_UPDATE_ALERT_TYPES_RESULT = "EDIT_ALERT_TYPE_SUPPORTED_UPDATE_ALERT_TYPES_RESULT";
